module.exports = __webpack_public_path__ + "static/hero-wedding-loan-e5861c29e1d86f83346860b64e5d194a.webp";